import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import { UserFilled } from '@next-common/material-ui-icons';
import StoreIcon from '@mui/icons-material/Store';
import * as styles from './AvatarLogo.style';
export function AvatarLogo({ logoUrl, width, height, iconSize, iconColor, isSeller = false }) {
    const [imgUrlError, setImgUrlError] = useState(false);
    const imgErrorHandler = () => {
        setImgUrlError(true);
    };
    return (React.createElement(Box, { sx: Object.assign(Object.assign({}, styles.content), { width: {
                xs: width || styles.mobAvatarSize,
                sm: width || styles.deskAvatarSize,
            }, height: {
                xs: height || styles.mobAvatarSize,
                sm: height || styles.deskAvatarSize,
            } }), component: "div", className: "_hy" }, logoUrl && !imgUrlError ? (React.createElement(Avatar, { sx: Object.assign(Object.assign({}, styles.combination), { width: {
                xs: width || styles.mobAvatarSize,
                sm: width || styles.deskAvatarSize,
            }, height: {
                xs: height || styles.mobAvatarSize,
                sm: height || styles.deskAvatarSize,
            } }), "data-qa": "avatar", variant: "rounded", src: logoUrl, imgProps: {
            onError: imgErrorHandler,
        } })) : (React.createElement(Avatar, { "data-qa": "avatar", variant: "rounded", sx: Object.assign(Object.assign({}, styles.errorCombination), { width: {
                xs: width || styles.mobAvatarSize,
                sm: width || styles.deskAvatarSize,
            }, height: {
                xs: height || styles.mobAvatarSize,
                sm: height || styles.deskAvatarSize,
            } }) }, isSeller ? (React.createElement(StoreIcon, { sx: Object.assign(Object.assign({}, styles.iconClass), { fontSize: {
                xs: iconSize || styles.mobIconSize,
                sm: iconSize || styles.deskIconSize,
            }, color: iconColor || 'inherit' }) })) : (React.createElement(UserFilled, { sx: {
            fontSize: {
                xs: iconSize || styles.mobIconSize,
                sm: iconSize || styles.deskIconSize,
            },
            color: iconColor || 'inherit',
        } }))))));
}
